import { render } from "./RightPanel.vue?vue&type=template&id=57b4f132&scoped=true&ts=true"
import script from "./RightPanel.vue?vue&type=script&lang=ts"
export * from "./RightPanel.vue?vue&type=script&lang=ts"

import "./RightPanel.vue?vue&type=style&index=0&id=57b4f132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b4f132"]])

export default __exports__